import { render, staticRenderFns } from "./promotions.vue?vue&type=template&id=1681ffd2&scoped=true&"
import script from "./promotions.vue?vue&type=script&lang=js&"
export * from "./promotions.vue?vue&type=script&lang=js&"
import style0 from "./promotions.vue?vue&type=style&index=0&id=1681ffd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1681ffd2",
  null
  
)

export default component.exports